import { render, staticRenderFns } from "./DriversFieldGroupsEditForm.vue?vue&type=template&id=a9b7d282&scoped=true&"
import script from "./DriversFieldGroupsEditForm.vue?vue&type=script&lang=js&"
export * from "./DriversFieldGroupsEditForm.vue?vue&type=script&lang=js&"
import style0 from "./DriversFieldGroupsEditForm.vue?vue&type=style&index=0&id=a9b7d282&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b7d282",
  null
  
)

export default component.exports